import PolicyLayout from './PolicyLayout';
import { ADDRESS, BRAND, COMPANY_NAME, SITE_DOMAIN } from '../constants/site';

export default function TermsOfService() {
  return (
    <PolicyLayout
      title="Terms of Service"
      updated="1 August 2026"
      intro={`These Terms of Service govern your use of ${SITE_DOMAIN} and any products or support services you purchase from us. Please read them carefully. By placing an order or using our website, you accept these terms in full.`}
    >
      <h2>About Us</h2>
      <p>
        {SITE_DOMAIN} is operated by <strong>{COMPANY_NAME}</strong>, registered at {ADDRESS}. We are
        an independent reseller of security software and a provider of third-party technical
        support. We are <strong>not</strong> affiliated with, endorsed by, or sponsored by {BRAND},
        LLC. All trademarks referenced belong to their respective owners and are used for
        identification purposes only.
      </p>

      <h2>Eligibility</h2>
      <p>
        You must be at least eighteen years old and legally able to enter into a binding contract to
        purchase from this website. By ordering, you confirm that the information you provide is
        accurate and that you are authorised to use the payment method supplied.
      </p>

      <h2>Products and Licences</h2>
      <p>
        We supply genuine software licences sourced through authorised distribution channels. Your
        purchase grants you a licence to use the software under the publisher&apos;s own end-user
        licence agreement, which takes precedence in matters relating to the software itself.
      </p>
      <ul>
        <li>Licence keys are delivered digitally to the email address supplied at checkout.</li>
        <li>Each key is valid for the stated number of devices and subscription term.</li>
        <li>Keys must not be resold, republished, or shared outside your household.</li>
        <li>Reactivation after a hardware change may require contacting our support desk.</li>
      </ul>

      <h2>Pricing and Payment</h2>
      <p>
        All prices are shown in US dollars and exclude any applicable local taxes unless stated
        otherwise. Promotional pricing applies to the first subscription term only; renewals are
        charged at the then-current standard rate. We reserve the right to correct pricing errors
        and to cancel any order affected by an obvious mistake, with a full refund issued.
      </p>

      <h2>Support Services</h2>
      <p>
        Technical support covers installation, activation, configuration, and basic troubleshooting
        of the software you purchased from us. Support is delivered by phone, email, or remote
        session with your explicit permission. Our specialists will never ask for banking passwords
        or one-time security codes.
      </p>
      <p>Support does not include:</p>
      <ul>
        <li>Hardware repair, data recovery, or operating system reinstallation.</li>
        <li>Software not purchased through us or outside the agreed scope.</li>
        <li>Removal of pre-existing damage caused by malware prior to installation.</li>
      </ul>

      <h2>Acceptable Use</h2>
      <p>
        You agree not to misuse this website. Prohibited activities include attempting to gain
        unauthorised access to our systems, scraping content at scale, introducing malicious code,
        impersonating another person, or using our services for any unlawful purpose.
      </p>

      <h2>Intellectual Property</h2>
      <p>
        All website content, including text, layout, graphics, and code, is owned by or licensed to
        us and protected by copyright. You may view and print pages for personal reference but may
        not reproduce, distribute, or republish any part of this site commercially without written
        permission.
      </p>

      <h2>Disclaimer of Warranties</h2>
      <p>
        This website and our support services are provided on an &ldquo;as is&rdquo; and &ldquo;as
        available&rdquo; basis. No security product can guarantee complete protection against every
        threat. We do not warrant that the software will be uninterrupted, error-free, or that it
        will detect every possible piece of malware.
      </p>

      <h2>Limitation of Liability</h2>
      <p>
        To the maximum extent permitted by law, our total liability arising out of or relating to
        your purchase is limited to the amount you actually paid for the product or service in
        question. We are not liable for indirect, incidental, special, or consequential damages,
        including loss of data, loss of profits, or business interruption.
      </p>

      <h2>Termination</h2>
      <p>
        We may suspend or terminate access to our services if these terms are breached, if
        fraudulent activity is detected, or if required by law. Termination does not affect any
        refund rights that have already accrued under our Refund Policy.
      </p>

      <h2>Governing Law</h2>
      <p>
        These terms are governed by the laws of the jurisdiction in which our business is
        registered, without regard to conflict of law principles. Any dispute will be resolved in
        the courts of that jurisdiction unless applicable consumer law grants you a different
        forum.
      </p>

      <h2>Changes to These Terms</h2>
      <p>
        We may revise these terms at any time. The version published on this page at the moment you
        place an order is the version that applies to that order. Continued use of the website after
        changes are posted constitutes acceptance of the revised terms.
      </p>
    </PolicyLayout>
  );
}
